import { useEffect, useState } from 'react';

import SpaceY from '../../../../components/SpaceY';
import UImage from '../../../../components/UImage';
import { Recipe } from '../../../../type';
import { RecipeFlag } from '../../../../type/recipe';
import { CommunityGtm } from '../../../../utils/gtm/community/communityGtm';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import CreatorAvatar from '../components/CreatorAvatar';
import RecipeCardOverlayTag from '../components/RecipeCardOverlayTag';
import ThumbnailGradation from '../components/ThumbnailGradation';
import VegetableList from '../VegetableList';

interface RecipeCurationCardProps {
  recipe: Recipe;
  thisWeekVegetables: string[];
  curationTitle: string;
  recipeFlag?: RecipeFlag;
}
const RecipeCurationCard = ({
  recipe,
  thisWeekVegetables,
  curationTitle,
  recipeFlag,
}: RecipeCurationCardProps) => {
  const history = useHistoryMethod();

  const [sortedIngredients, setSortedIngredients] = useState<string[]>([]);
  const [hover, setHover] = useState(false);

  const profileImage =
    recipe.recipeCreator?.profileImage || recipe.authorThumbnail;
  const creatorName = recipe.recipeCreator?.name || recipe.authorName;

  const handleClickCurationCard = () => {
    const communityGtm = new CommunityGtm();
    communityGtm.click_recipe({
      recipe_id: recipe.id.toString(),
      recipe_name: recipe.name,
      created_by: communityGtm.util.created_by({
        authorName: recipe.authorName,
      }),
    });
    history.push(`/recipes/${recipe.id}`);
  };

  useEffect(() => {
    let thisWeekIngredients: string[] = [];
    let notThisWeekIngredients: string[] = [];
    recipe.mainIngredient.forEach((ingredient) => {
      if (thisWeekVegetables.includes(ingredient.name)) {
        thisWeekIngredients.push(ingredient.name);
      } else {
        notThisWeekIngredients.push(ingredient.name);
      }
    });
    setSortedIngredients([...thisWeekIngredients, ...notThisWeekIngredients]);
  }, [recipe.mainIngredient, thisWeekVegetables]);

  return (
    <div
      onClick={handleClickCurationCard}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="relative w-300px cursor-pointer overflow-hidden"
    >
      {/* Thumbnail */}
      <div className="relative h-240px overflow-hidden rounded-10px bg-cover bg-center bg-no-repeat">
        <RecipeCardOverlayTag.Wrapper
          borderRadius="rounded-br-[10px]"
          position="left-0"
        >
          <RecipeCardOverlayTag.Flag recipe={recipe} recipeFlag={recipeFlag} />
          <RecipeCardOverlayTag.Bookmark recipe={recipe} />
        </RecipeCardOverlayTag.Wrapper>
        <div
          className={`absolute inset-0 flex items-center justify-center transition-transform duration-200 ${
            hover ? 'scale-110' : 'scale-100'
          }`}
        >
          <UImage
            src={recipe.images[0]}
            alt={recipe.name}
            width={320}
            height={240}
            className="h-full w-full object-cover object-center"
          />
        </div>
        <ThumbnailGradation />

        <div
          onClick={(e) => {
            e.stopPropagation();
            const creatorName = recipe.recipeCreator?.name || recipe.authorName;

            history.push(`/recipes/creator/${creatorName}`);
          }}
          className="flex-center absolute bottom-16px w-full gap-8px px-16px"
        >
          <CreatorAvatar
            size={32}
            image={profileImage}
            isCertified={recipe?.recipeCreator?.isCertified ?? false}
          />
          <span className="text-14px font-medium text-white">
            {creatorName}
          </span>
        </div>
      </div>

      {/* Title & Ingredients */}
      <div className="px-16px pt-16px">
        <p className="text-center text-18px font-bold text-gray-800">
          {recipe.name}
        </p>
        <SpaceY height="12px" />
        <VegetableList
          large
          names={sortedIngredients}
          thisWeekVegetables={thisWeekVegetables}
          bookmarkCount={recipe.bookmarkCount}
        />
      </div>
    </div>
  );
};

export default RecipeCurationCard;
